
























import Vue from 'vue'
import BaseImage from '@/common/components/BaseImage.vue'

import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
import { NamingEditor } from '@/stockLibrary/queries/types'

export default Vue.extend({
  components: { BaseImage },
  props: {
    namingEditor: {
      type: Object as () => NamingEditor,
      required: true
    },
    designImgUrl: {
      type: String,
      required: true
    }
  },
  data(): {
    designPosition: {
      width: number
      height: number
      top: number
      left: number
    }
  } {
    return {
      designPosition: {
        width: 0,
        height: 0,
        top: 0,
        left: 0
      }
    }
  },
  computed: {
    squarePlaceholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    },
    designImgStyles(): { [key: string]: string } {
      return {
        top: this.designPosition.top + 'px',
        left: this.designPosition.left + 'px',
        width: this.designPosition.width + 'px',
        height: this.designPosition.height + 'px'
      }
    }
  },
  mounted() {
    this.$nextTick(() => this.calculateDesignPosition())
    window.addEventListener('resize', this.calculateDesignPosition)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateDesignPosition)
  },
  methods: {
    calculateDesignPosition() {
      const previewArea = {
        height: (this.$refs.previewArea as HTMLElement).clientHeight,
        width: (this.$refs.previewArea as HTMLElement).clientWidth
      }

      this.designPosition.width = Math.floor((this.namingEditor.width * previewArea.width) / this.namingEditor.displayWidth)
      this.designPosition.height = Math.floor((this.namingEditor.height * previewArea.height) / this.namingEditor.displayHeight)
      this.designPosition.top = Math.floor((this.namingEditor.top * previewArea.height) / this.namingEditor.displayHeight)
      this.designPosition.left = Math.floor((this.namingEditor.left * previewArea.width) / this.namingEditor.displayWidth)
    }
  }
})
